import { useEffect, useRef, useState } from "react";

import history2023Img1 from "@/assets/images/user/history2023Img1.jpg";
import history2023Img2 from "@/assets/images/user/history2023Img2.jpg";
import history2023Img3 from "@/assets/images/user/history2023Img3.jpg";
import history2023Img4 from "@/assets/images/user/history2023Img4.jpg";
import history2023Img5 from "@/assets/images/user/history2023Img5.jpg";
import history2023Img6 from "@/assets/images/user/history2023Img6.jpg";
import history2023Img7 from "@/assets/images/user/history2023Img7.jpg";
import history2023Img8 from "@/assets/images/user/history2023Img8.jpg";
import history2023Img9 from "@/assets/images/user/history2023Img9.jpg";
import history2023Img10 from "@/assets/images/user/history2023Img10.jpg";
import history2023Img11 from "@/assets/images/user/history2023Img11.jpg";
import history2023Img12 from "@/assets/images/user/history2023Img12.jpg";
import history2023Poster from "@/assets/images/user/history2023Poster.jpg";
import history2024Img1 from "@/assets/images/user/history2024Img1.jpg";
import history2024Img2 from "@/assets/images/user/history2024Img2.jpg";
import history2024Img3 from "@/assets/images/user/history2024Img3.jpg";
import history2024Img4 from "@/assets/images/user/history2024Img4.jpg";
import history2024Img5 from "@/assets/images/user/history2024Img5.jpg";
import history2024Img6 from "@/assets/images/user/history2024Img6.jpg";
import history2024Img7 from "@/assets/images/user/history2024Img7.jpg";
import history2024Img8 from "@/assets/images/user/history2024Img8.jpg";
import history2024Img9 from "@/assets/images/user/history2024Img9.jpg";
import history2024Img10 from "@/assets/images/user/history2024Img10.jpg";
import history2024Img11 from "@/assets/images/user/history2024Img11.jpg";
import history2024Img12 from "@/assets/images/user/history2024Img12.jpg";
import history2024Poster from "@/assets/images/user/history2024Poster.jpg";
import history2025Img1 from "@/assets/images/user/history2025Img1.png";
import history2025Img2 from "@/assets/images/user/history2025Img2.png";
import history2025Img3 from "@/assets/images/user/history2025Img3.png";
import history2025Img4 from "@/assets/images/user/history2025Img4.png";
import history2025Img5 from "@/assets/images/user/history2025Img5.png";
import history2025Img6 from "@/assets/images/user/history2025Img6.png";
import history2025Img7 from "@/assets/images/user/history2025Img7.png";
import history2025Img8 from "@/assets/images/user/history2025Img8.png";
import history2025Img9 from "@/assets/images/user/history2025Img9.png";
import history2025Img10 from "@/assets/images/user/history2025Img10.png";
import history2025Img11 from "@/assets/images/user/history2025Img11.png";
import history2025Img12 from "@/assets/images/user/history2025Img12.png";
import history2025Poster from "@/assets/images/user/history2025Poster.jpg";
import icPause from "@/assets/images/user/icPause.svg";
import icPlay from "@/assets/images/user/icPlay.svg";
import programArt from "@/assets/images/user/programArt.svg";
import programFesta from "@/assets/images/user/programFesta.svg";
import programFocus from "@/assets/images/user/programFocus.svg";
import programPlay from "@/assets/images/user/programPlay.svg";
import programShow from "@/assets/images/user/programShow.svg";
import programSpeech from "@/assets/images/user/programSpeech.svg";
import programStage from "@/assets/images/user/programStage.svg";
import programStay from "@/assets/images/user/programStay.svg";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";
import ImgPop from "@/components/user/popup/ImgPop";

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        YT: any;
        onYouTubeIframeAPIReady: () => void;
    }
}

const program2025List = [
    {
        title: "무대 프로그램",
        background: "bg-program202501",
        img: programStage,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex flex-col gap-[8px]">
                    <p className="font-['GongGothicBold'] text-[#FF5B2E]">MAIN STAGE DAY1</p>
                    <p>
                        사전 공연 <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        GXG 2025 개막식&축하 공연 <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        The 2nd GXG SOUND TRACK
                    </p>
                </li>
                <li className="flex flex-col gap-[8px]">
                    <p className="font-['GongGothicBold'] text-[#FF5B2E]">MAIN STAGE DAY2</p>
                    <p>
                        일러스타 페스 STAGE <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        GXG 플레이 타임 <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        GXG 갈라 콘서트
                    </p>
                </li>
                <li className="flex flex-col gap-[8px]">
                    <p className="font-['GongGothicBold'] text-[#FF5B2E]">SUB STAGE DAY1 & DAY2</p>
                    <p>GXG 버스킹 타임</p>
                </li>
            </ul>
        ),
    },
    {
        title: "체험 프로그램",
        background: "bg-program202502",
        img: programPlay,
        contents: (
            <p>
                브랜드 체험존
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 마켓
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 플레이 라운지
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                Cool Station with 동아오츠카
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 캠퍼스 아케이드
            </p>
        ),
    },
    {
        title: "전시 프로그램",
        background: "bg-program202503",
        img: programArt,
        contents: (
            <p>
                GXG 씨어터
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 아트북 라운지
            </p>
        ),
    },
    {
        title: "GXG 컨퍼런스",
        background: "bg-program202504",
        img: programFocus,
        contents: (
            <>
                <p>
                    GXG 2025 컨퍼런스 NEXT PLAY <br className="md:hidden" />
                    with Microsoft Cloud & AI
                </p>
                {/* <a
                    href="https://2025gxgconference.co.kr/"
                    target="_blank"
                    rel="noreferrer"
                    className="m-[20px_auto_0] relative block w-full h-[72px] text-white text-[20px] text-center leading-[70px] font-['GongGothicMedium'] clip-path-octagon border border-black bg-black max-w-[320px]"
                >
                    <span>GXG 2025 컨퍼런스 신청하기</span>
                    <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
                    <span className="absolute left-0 bottom-0 border-[8px] border-black border-t-transparent border-r-transparent" />
                    <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
                    <span className="absolute right-0 bottom-0 border-[8px] border-black border-t-transparent border-l-transparent" />
                </a> */}
            </>
        ),
    },
    {
        title: "GXG 콜라보레이션",
        background: "bg-program202505",
        img: programFesta,
        contents: (
            <p>
                인디크래프트
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>일러스타 페스
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>성남청년 플리마켓
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                <br className="md:hidden" />
                GV2025
            </p>
        ),
    },
];

const program2024List = [
    {
        title: "무대 프로그램",
        background: "bg-program202401",
        img: programStage,
        contents: (
            <p>
                게임OST 국악 콘서트&nbsp;&nbsp;I&nbsp;&nbsp;GXG 2024 개막식&축하 공연
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>게임음악 경연대회
                <br className="hidden md:block" />
                <span className="md:hidden">&nbsp;&nbsp;I&nbsp;&nbsp;</span>일러스타 페스 스테이지
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span> WCG 스테이지
                &nbsp;&nbsp;I&nbsp;&nbsp;GXG 2024 갈라 콘서트
            </p>
        ),
    },
    {
        title: "전시형 프로그램",
        background: "bg-program202402",
        img: programArt,
        contents: <p>브랜드 체험존&nbsp;&nbsp;I&nbsp;&nbsp;GXG 마켓&nbsp;&nbsp;I&nbsp;&nbsp;버스킹 라운지</p>,
    },
    {
        title: "참여형 프로그램",
        background: "bg-program202403",
        img: programPlay,
        contents: <p>게임문화전시&nbsp;&nbsp;I&nbsp;&nbsp;사회공헌전시&nbsp;&nbsp;I&nbsp;&nbsp;테라시아 특별전</p>,
    },
    {
        title: "GXG 콜라보레이션",
        background: "bg-program202404",
        img: programFesta,
        contents: (
            <p>GXG x 인디크래프트&nbsp;&nbsp;I&nbsp;&nbsp;GXG x WCG&nbsp;&nbsp;I&nbsp;&nbsp;GXG x 일러스타 페스</p>
        ),
    },
];

const program2023List = [
    {
        title: "무대 프로그램",
        background: "bg-program202301",
        img: programStage,
        contents: (
            <p>
                개막 기념 창작 뮤지컬 <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                GXG 2023 개막식 & 축하 공연<span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                <br className="md:hidden" />
                게임 기업 직장인 동아리 밴드 공연 <br />
                게임 OST 오케스트라&nbsp;&nbsp;I&nbsp;&nbsp;코스프레 포토타임
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                게임 경매 이벤트&nbsp;&nbsp;I&nbsp;&nbsp;뚱종원(나선욱)의 겜쿡비책
                <br />
                성남 청년 버스킹 공연 (2023 성남 청년 문화 축제)
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>2023 게임제너레이션
                게임비평공모전 시상식
            </p>
        ),
    },
    {
        title: "전시・체험 프로그램",
        background: "bg-program202302",
        img: programShow,
        contents: (
            <p>
                기업 참여 전시&nbsp;&nbsp;I&nbsp;&nbsp;사회공헌전시&nbsp;&nbsp;I&nbsp;&nbsp;라이징 인디게임존
                <br />
                나승훈 웹툰작가 : 라이브 드로잉
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>흑요석 작가 : 팬사인회
            </p>
        ),
    },
    {
        title: "컨퍼런스 프로그램",
        background: "bg-program202303",
        img: programSpeech,
        contents: (
            <p>
                문화예술분야 연사 참여 컨퍼런스 (세상무대 / 상상무대)
                <br />
                라이징 인디게임 시상식
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                2023 신구대학교 전국 중고교생 게임 공모전
            </p>
        ),
    },
    {
        title: "네트워킹 프로그램",
        background: "bg-program202304",
        img: programStay,
        contents: (
            <p>
                게임 문화인 대상 오픈형 네트워킹 공간
                <br className="md:hidden " />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>Microsoft Korea & 띵스플로우
                전시
            </p>
        ),
    },
];

const program2025ImgList = [
    { title: "GXG 2025 전경", img: history2025Img1 },
    { title: "GXG 2025 개막식", img: history2025Img2 },
    { title: "The 2nd GXG SOUND TRACK", img: history2025Img3 },
    { title: "GXG 2025 갈라 콘서트", img: history2025Img4 },
    { title: "브랜드 체험존", img: history2025Img5 },
    { title: "브랜드 체험존", img: history2025Img6 },
    { title: "플레이 라운지", img: history2025Img7 },
    { title: "GXG 씨어터", img: history2025Img8 },
    { title: "아트북 라운지", img: history2025Img9 },
    { title: "GXG 컨퍼런스", img: history2025Img10 },
    { title: "GXG X 인디크래프트", img: history2025Img11 },
    { title: "GXG x 일러스타페스", img: history2025Img12 },
];

const program2024ImgList = [
    { title: "GXG 2024 전경", img: history2024Img1 },
    { title: "GXG 2024 개막식", img: history2024Img2 },
    { title: "The 1st GXG SOUND TRACK", img: history2024Img3 },
    { title: "GXG 2024 갈라 콘서트", img: history2024Img4 },
    { title: "게임문화전시", img: history2024Img5 },
    { title: "브랜드 체험존", img: history2024Img6 },
    { title: "GXG 마켓", img: history2024Img7 },
    { title: "GXG 이벤트존", img: history2024Img8 },
    { title: "GXG 버스킹 라운지", img: history2024Img9 },
    { title: "GXG x 인디크래프트", img: history2024Img10 },
    { title: "GXG x 일러스타페스", img: history2024Img11 },
    { title: "GXG x WCG", img: history2024Img12 },
];

const program2023ImgList = [
    { title: "GXG 2023 전경", img: history2023Img1 },
    { title: "GXG 2023 실내 전경", img: history2023Img2 },
    { title: "GXG 2023 현장 스케치", img: history2023Img3 },
    { title: "GXG 2023 개막식", img: history2023Img4 },
    { title: "게임OST 오케스트라 콘서트", img: history2023Img5 },
    { title: "코스프레 콘테스트", img: history2023Img6 },
    { title: "부대 프로그램", img: history2023Img7 },
    { title: "브랜드 전시/체험", img: history2023Img8 },
    { title: "THE SHOW 라이브 드로잉", img: history2023Img9 },
    { title: "THE SHOW 팬사인회", img: history2023Img10 },
    { title: "THE SPEECH 세상무대", img: history2023Img11 },
    { title: "THE SPEECH 상상무대", img: history2023Img12 },
];

const yearTabs = ["2025", "2024", "2023"] as const;
type YearTab = (typeof yearTabs)[number];

export default function History() {
    const [activeYear, setActiveYear] = useState<YearTab>("2025");
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPlaying2025, setIsPlaying2025] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const playerRef = useRef<any>(null);
    const playerContainerRef = useRef<HTMLDivElement>(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const player2025Ref = useRef<any>(null);
    const player2025ContainerRef = useRef<HTMLDivElement>(null);
    // YouTube IFrame API 준비 여부 / 현재 활성 연도(스테일 클로저 방지)
    const apiReadyRef = useRef(false);
    const activeYearRef = useRef<YearTab>(activeYear);
    useEffect(() => {
        activeYearRef.current = activeYear;
    }, [activeYear]);

    const handleTabChange = (year: YearTab) => {
        if (year === activeYear) return;
        if (playerRef.current?.pauseVideo) {
            playerRef.current.pauseVideo();
        }
        if (player2025Ref.current?.pauseVideo) {
            player2025Ref.current.pauseVideo();
        }
        setActiveYear(year);
    };

    // 2024 하이라이트 플레이어 생성
    // 최초엔 2024 섹션이 display:none(0×0)이라 이 시점에 만들면 YouTube가 저해상도 썸네일을
    // 잡아 확대돼 깨져 보인다. 그래서 2024 탭이 활성화(크기 확정)된 뒤에 지연 생성한다.
    const createPlayer2024 = () => {
        if (playerRef.current || !apiReadyRef.current || !playerContainerRef.current) return;
        playerRef.current = new window.YT.Player(playerContainerRef.current, {
            height: "100%",
            width: "100%",
            videoId: "csUOprB7oxQ",
            playerVars: {
                autoplay: 0,
                controls: 0,
                rel: 0,
                showinfo: 0,
                modestbranding: 1,
            },
            events: {
                onStateChange: onPlayerStateChange,
            },
        });
    };

    useEffect(() => {
        // YouTube API 로드
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

        // API 준비되면 플레이어 생성
        window.onYouTubeIframeAPIReady = () => {
            apiReadyRef.current = true;
            // 2025 플레이어는 초기 노출 상태이므로 즉시 생성(고해상도 썸네일 정상)
            if (player2025ContainerRef.current) {
                player2025Ref.current = new window.YT.Player(player2025ContainerRef.current, {
                    height: "100%",
                    width: "100%",
                    videoId: "Itw53IW0kbQ",
                    playerVars: {
                        autoplay: 0,
                        controls: 0,
                        rel: 0,
                        showinfo: 0,
                        modestbranding: 1,
                    },
                    events: {
                        onStateChange: onPlayer2025StateChange,
                    },
                });
            }
            // API 준비 전에 이미 2024 탭으로 이동한 경우 대비
            if (activeYearRef.current === "2024") {
                createPlayer2024();
            }
        };

        return () => {
            if (playerRef.current) {
                playerRef.current.destroy();
            }
            if (player2025Ref.current) {
                player2025Ref.current.destroy();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 2024 탭이 활성화되면(컨테이너 크기 확정) 플레이어를 지연 생성
    useEffect(() => {
        if (activeYear === "2024") {
            createPlayer2024();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeYear]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onPlayerStateChange = (event: any) => {
        // 1: 재생 중, 2: 일시정지, 0: 종료
        if (event.data === 1) {
            setIsPlaying(true);
        } else if (event.data === 2 || event.data === 0) {
            setIsPlaying(false);
        }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onPlayer2025StateChange = (event: any) => {
        if (event.data === 1) {
            setIsPlaying2025(true);
        } else if (event.data === 2 || event.data === 0) {
            setIsPlaying2025(false);
        }
    };

    const togglePlay = () => {
        if (playerRef.current) {
            if (isPlaying) {
                playerRef.current.pauseVideo();
            } else {
                playerRef.current.playVideo();
            }
        }
    };

    const togglePlay2025 = () => {
        if (player2025Ref.current) {
            if (isPlaying2025) {
                player2025Ref.current.pauseVideo();
            } else {
                player2025Ref.current.playVideo();
            }
        }
    };

    return (
        <div>
            <div className="sticky top-[88px] z-[3] border-b border-[#ddd] bg-[#f1f4f9] xl:top-[117px]">
                <ul className="mx-auto flex w-full max-w-[1400px] items-center justify-center gap-[14px] md:gap-[60px]">
                    {yearTabs.map(year => {
                        const isActive = activeYear === year;
                        return (
                            <li key={year} className="flex">
                                <button
                                    type="button"
                                    onClick={() => handleTabChange(year)}
                                    className={`flex items-center justify-center whitespace-nowrap border-b-[4px] py-3 font-['GongGothicBold'] text-[16px] leading-none tracking-[-0.56px] transition-colors md:py-[20px] md:text-[28px] ${
                                        isActive
                                            ? "border-[#7c65db] text-[#7c65db]"
                                            : "border-transparent text-black hover:border-[#7c65db] hover:text-[#7c65db]"
                                    }`}
                                >
                                    GXG {year}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className="px-[20px] pt-[40px] md:pt-[60px] xl:px-0">
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[60px] md:pb-[60px] ${activeYear === "2025" ? "" : "hidden"}`}
                >
                    <TitleBox title="GXG HISTORY" text="GXG 2025 다시보기" />
                    <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                        <div>
                            <img src={history2025Poster} alt="GXG 2025" className="w-[628px] max-w-full" />
                        </div>
                        <div className="w-full pt-[40px] md:pt-[60px] xl:flex xl:flex-1 xl:flex-col xl:justify-between xl:pt-0">
                            <ul className="flex flex-col gap-[12px] md:gap-[16px]">
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"행사명"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        GXG 2025 <br className="md:hidden" />
                                        <span className="text-[14px] md:text-[20px]">
                                            (Game culture X Generation 2025)
                                        </span>
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"일  정"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        9월 19일(금) ~ 20일(토), 2일 간
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"장  소"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        경기도 성남시 판교역 일대
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"주  최"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        성남시
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"주  관"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        성남산업진흥원, 게임문화재단
                                    </p>
                                </li>
                                <li className="flex items-start gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"후  원"}
                                    </p>
                                    <p className="flex-1 pt-[10px] font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:pt-[8px] md:text-[20px]">
                                        문화체육관광부, 한국콘텐츠진흥원, <br className="md:hidden" />
                                        게임물관리위원회, <br className="hidden md:block" />
                                        경기도, 경기관광공사, <br className="md:hidden" />
                                        성남시청소년청년재단, 넥슨코리아, <br className="md:hidden" />
                                        엔씨소프트, 호요버스, 슈퍼셀, <br className="md:hidden" />
                                        펄어비스, 레드프린팅, 동아오츠카, 마이크로소프트, <br className="md:hidden" />
                                        클라우디드 레오파드 엔터테인먼트코리아
                                    </p>
                                </li>
                            </ul>
                            <div>
                                <p className="p-[40px_0_12px] font-['GongGothicMedium'] text-[24px] leading-[28px] text-black xl:p-[20px_0]">
                                    프로그램
                                </p>
                                <ProgramAccordion
                                    list={program2025List}
                                    className="xl:[&_h3]:h-[55.5px] xl:[&_h3_img]:h-[23px] xl:[&_h3_svg]:h-10 xl:[&_h3_svg]:w-10 xl:[&_h3_img+p]:text-[20px]"
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[60px] md:pb-[60px] ${activeYear === "2025" ? "" : "hidden"}`}
                >
                    <SubTitle title="하이라이트 (2025)" className="pb-[24px] md:pb-[40px]" />
                    <div className="group relative h-[200px] overflow-hidden rounded-[20px_0_20px_0] border-2 border-[#E64C88] bg-[#f9f9f9] shadow-[8px_8px_0_0_#D456A0] md:h-[400px] md:rounded-[60px_0_60px_0] md:border-4 md:shadow-[16px_16px_0_0_#D456A0] xl:h-[720px]">
                        <div ref={player2025ContainerRef} className="h-full w-full" />
                        <button
                            type="button"
                            onClick={togglePlay2025}
                            className="absolute left-1/2 top-1/2 hidden size-[140px] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-[8px] rounded-full bg-videoBtnBg pt-[40px] opacity-0 transition-all group-hover:opacity-100 md:flex"
                        >
                            <img src={isPlaying2025 ? icPause : icPlay} alt="동영상버튼" />
                            <p className="font-['Handjet'] text-[20px] text-white">
                                {isPlaying2025 ? "PAUSE" : "PLAY"}
                            </p>
                        </button>
                    </div>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[120px] md:pb-[160px] ${activeYear === "2025" ? "" : "hidden"}`}
                >
                    <SubTitle title="현장스케치 (2025)" className="pb-[24px] md:pb-[40px]" />
                    <ul className="grid grid-cols-1 gap-[28px] md:grid-cols-2 md:gap-x-[24px] md:gap-y-[40px] xl:grid-cols-4">
                        {program2025ImgList.map((img, i) => (
                            <li key={`img_${i}`}>
                                <Dialog>
                                    <DialogTrigger asChild>
                                        <div className="cursor-pointer">
                                            <div className="group relative h-0 w-full overflow-hidden pb-[67%] transition-all duration-500 before:absolute before:z-[2] before:h-full before:w-full before:border-4 before:border-transparent before:opacity-0 before:transition-all before:duration-500 before:content-[''] before:[border-image:linear-gradient(135deg,#E64C88_0%,#3734C3_100%)_1] hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)] before:hover:opacity-100">
                                                <img
                                                    src={img.img}
                                                    alt={img.title}
                                                    className="absolute inset-0 z-[1] h-full w-full object-cover transition-all duration-500 group-hover:scale-[1.2]"
                                                />
                                            </div>
                                            <p className="pt-[16px] text-[24px] font-[600] text-black">{img.title}</p>
                                        </div>
                                    </DialogTrigger>
                                    <ImgPop title={img.title}>
                                        <ScrollArea className="max-h-[60vh]">
                                            <div className="p-[10px_20px_20px]">
                                                <img src={img.img} alt={img.title} />
                                            </div>
                                        </ScrollArea>
                                    </ImgPop>
                                </Dialog>
                            </li>
                        ))}
                    </ul>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[60px] md:pb-[80px] ${activeYear === "2024" ? "" : "hidden"}`}
                >
                    <TitleBox title="GXG HISTORY" text="GXG 2024 다시보기" />
                    <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                        <div>
                            <img src={history2024Poster} alt="GXG 2024" />
                        </div>
                        <div className="w-full pt-[40px] md:pt-[60px] xl:flex xl:flex-1 xl:flex-col xl:justify-between xl:pt-0">
                            <ul className="flex flex-col gap-[12px] md:gap-[16px]">
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"행사명"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        GXG 2024 <br className="md:hidden" />
                                        <span className="text-[14px] md:text-[20px]">
                                            (Game culture X Generation 2024)
                                        </span>
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"일  정"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        2024년 9월 6일(금)~7일(토)
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"장  소"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        경기도 성남시 판교역 일대
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"주  최"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        성남시
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"주  관"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        성남산업진흥원, 게임문화재단
                                    </p>
                                </li>
                                <li className="flex items-start gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"후  원"}
                                    </p>
                                    <p className="flex-1 pt-[10px] font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:pt-[8px] md:text-[20px]">
                                        문화체육관광부, 한국콘텐츠진흥원, <br className="md:hidden" />
                                        게임물관리위원회, <br className="hidden xl:block" />
                                        성남시청소년재단, <br className="xl:hidden" />
                                        넥슨코리아, 엔씨소프트, 슈퍼셀, 펄어비스,{` `}{" "}
                                        <br className="hidden xl:block" />
                                        레드프린팅 앤 프레스, <br className="hidden md:block xl:hidden" />
                                        스튜디오메타케이, <br className="md:hidden" />
                                        이모션웨이브, 판교 테크원
                                    </p>
                                </li>
                            </ul>
                            <div>
                                <p className="p-[40px_0_12px] font-['GongGothicMedium'] text-[24px] leading-[28px] text-black xl:p-[20px_0]">
                                    프로그램
                                </p>
                                <ProgramAccordion list={program2024List} />
                            </div>
                        </div>
                    </div>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[60px] md:pb-[80px] ${activeYear === "2024" ? "" : "hidden"}`}
                >
                    <SubTitle title="하이라이트 (2024)" className="pb-[24px] md:pb-[40px]" />
                    <div className="group relative h-[200px] overflow-hidden rounded-[20px_0_20px_0] border-2 border-transparent bg-gradient-to-br from-[#E64C88] to-[#3734C3] bg-origin-border shadow-[8px_8px_0_0_#D456A0] md:h-[400px] md:rounded-[60px_0_60px_0] md:border-4 md:shadow-[16px_16px_0_0_#D456A0] xl:h-[720px]">
                        <div ref={playerContainerRef} className="h-full w-full" />
                        <button
                            type="button"
                            onClick={togglePlay}
                            className="absolute left-1/2 top-1/2 hidden size-[140px] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-[8px] rounded-full bg-videoBtnBg pt-[40px] opacity-0 transition-all group-hover:opacity-100 md:flex"
                        >
                            <img src={isPlaying ? icPause : icPlay} alt="동영상버튼" />
                            <p className="font-['Handjet'] text-[20px] text-white">{isPlaying ? "PAUSE" : "PLAY"}</p>
                        </button>
                    </div>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[120px] md:pb-[160px] ${activeYear === "2024" ? "" : "hidden"}`}
                >
                    <SubTitle title="현장스케치 (2024)" className="pb-[24px] md:pb-[40px]" />
                    <ul className="grid grid-cols-1 gap-[28px] md:grid-cols-2 md:gap-x-[24px] md:gap-y-[40px] xl:grid-cols-4">
                        {program2024ImgList.map((img, i) => (
                            <li key={`img_${i}`}>
                                <Dialog>
                                    <DialogTrigger asChild>
                                        <div className="cursor-pointer">
                                            <div className="group relative h-0 w-full overflow-hidden pb-[67%] transition-all duration-500 before:absolute before:z-[2] before:h-full before:w-full before:border-4 before:border-transparent before:opacity-0 before:transition-all before:duration-500 before:content-[''] before:[border-image:linear-gradient(135deg,#E64C88_0%,#3734C3_100%)_1] hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)] before:hover:opacity-100">
                                                <img
                                                    src={img.img}
                                                    alt={img.title}
                                                    className="absolute inset-0 z-[1] h-full w-full object-cover transition-all duration-500 group-hover:scale-[1.2]"
                                                />
                                            </div>
                                            <p className="pt-[16px] text-[24px] font-[600] text-black">{img.title}</p>
                                        </div>
                                    </DialogTrigger>
                                    <ImgPop title={img.title}>
                                        <ScrollArea className="max-h-[60vh]">
                                            <div className="p-[10px_20px_20px]">
                                                <img src={img.img} alt={img.title} />
                                            </div>
                                        </ScrollArea>
                                    </ImgPop>
                                </Dialog>
                            </li>
                        ))}
                    </ul>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[60px] md:pb-[80px] ${activeYear === "2023" ? "" : "hidden"}`}
                >
                    <TitleBox title="GXG HISTORY" text="GXG 2023 다시보기" />
                    <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                        <div>
                            <img src={history2023Poster} alt="GXG 2023" />
                        </div>
                        <div className="w-full pt-[40px] md:pt-[60px] xl:flex xl:flex-1 xl:flex-col xl:justify-between xl:pt-0">
                            <ul className="flex flex-col gap-[12px] md:gap-[16px]">
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"행사명"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        GXG 2023 <br className="md:hidden" />
                                        <span className="text-[14px] md:text-[20px]">
                                            (Game culture X Generation 2023)
                                        </span>
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"일  정"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        2023년 9월 8일(금)~9일(토)
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"장  소"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        판교역 광장, 판교 테크원, <br className="md:hidden" />
                                        카카오 판교아지트
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"주  최"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        성남시
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"주  관"}
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        성남산업진흥원, 게임문화재단, <br className="md:hidden" />
                                        한국게임산업협회
                                    </p>
                                </li>
                                <li className="flex items-start gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        {"후  원"}
                                    </p>
                                    <p className="flex-1 pt-[10px] font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:pt-[8px] md:text-[20px]">
                                        문화체육관광부, 한국콘텐츠진흥원, <br className="md:hidden" />
                                        넥슨코리아, 엔씨소프트, 판교 테크원, <br className="xl:hidden" />
                                        레드프린팅앤프레스, 맥파이, <br className="md:hidden" />
                                        게임코치 아카데미, 성남시청소년재단
                                    </p>
                                </li>
                            </ul>
                            <div>
                                <p className="p-[40px_0_12px] font-['GongGothicMedium'] text-[24px] leading-[28px] text-black xl:p-[20px_0]">
                                    프로그램
                                </p>
                                <ProgramAccordion list={program2023List} />
                            </div>
                        </div>
                    </div>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[120px] md:pb-[160px] ${activeYear === "2023" ? "" : "hidden"}`}
                >
                    <SubTitle title="현장스케치 (2023)" className="pb-[24px] md:pb-[40px]" />
                    <ul className="grid grid-cols-1 gap-[28px] md:grid-cols-2 md:gap-x-[24px] md:gap-y-[40px] xl:grid-cols-4">
                        {program2023ImgList.map((img, i) => (
                            <li key={`img_${i}`}>
                                <Dialog>
                                    <DialogTrigger asChild>
                                        <div className="cursor-pointer">
                                            <div className="group relative h-0 w-full overflow-hidden pb-[67%] transition-all duration-500 before:absolute before:z-[2] before:h-full before:w-full before:border-4 before:border-transparent before:opacity-0 before:transition-all before:duration-500 before:content-[''] before:[border-image:linear-gradient(135deg,#E64C88_0%,#3734C3_100%)_1] hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)] before:hover:opacity-100">
                                                <img
                                                    src={img.img}
                                                    alt={img.title}
                                                    className="absolute inset-0 z-[1] h-full w-full object-cover transition-all duration-500 group-hover:scale-[1.2]"
                                                />
                                            </div>
                                            <p className="pt-[16px] text-[24px] font-[600] text-black">{img.title}</p>
                                        </div>
                                    </DialogTrigger>
                                    <ImgPop title={img.title}>
                                        <ScrollArea className="max-h-[60vh]">
                                            <div className="p-[10px_20px_20px]">
                                                <img src={img.img} alt={img.title} />
                                            </div>
                                        </ScrollArea>
                                    </ImgPop>
                                </Dialog>
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    );
}
